export enum SelectGridEmphasis {
  high = 'high',
  normal = 'normal',
  low = 'low'
}

export interface SelectGridOption {
  label: string;
  selected?: boolean;
  disabled?: boolean;
  emphasis?: SelectGridEmphasis;
  range?: boolean;

  [key: string]: any;
}
